import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { FaUserPlus, FaUserCog, FaEnvelope, FaLock, FaPhone, FaBuilding, FaBriefcase, FaArrowLeft } from "react-icons/fa";
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";
import { Base_Url, addEmployee } from '../../../config/config';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const schema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    department: z.string().min(1, "Department is required"),
    phone: z.string().length(10, "Phone number must be 10 digits"),
    role: z.string().min(1, "Role is required"),
    company_name: z.string().min(1, "Company name is required")
});

const AddUser = () => {
    const token = localStorage.getItem('token');
    const naviagteToAllEmployee = useNavigate();
    const cus_id = localStorage.getItem('cus_id');
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isToggleSidebar, isDarkMode } = useMyContext();
    const [roles, setRoles] = useState([
        { id: "PXROLE67e68d8fd9990", name: "Admin" },
        { id: "PXROLE67e68d8fd9991", name: "Manager" },
        { id: "PXROLE67e68d8fd9992", name: "Employee" }
    ]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            name: "",
            email: "",
            password: "",
            department: "",
            phone: "",
            role: "",
            company_name: ""
        }
    });

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;

        if (id === 'phone') {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
        }

        if (['name', 'department', 'company_name'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;
        }
    };

    const handleSelectChange = (selectedValues) => {
        if (selectedValues && selectedValues.length > 0) {
            setValue('role', selectedValues[0].id);
        }
    };

    const navigate = useNavigate();

    const onSubmit = async (data, event) => {
        const apiurl = Base_Url + addEmployee;
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                apiurl,
                data,
                {
                    headers: {
                        token,
                        'Content-Type': 'application/json',
                        cus_id: cus_id

                    }
                }
            );
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                naviagteToAllEmployee("/allEmployee");
                reset();
                setIsSubmitting(false);
            }
            else {
                toast.error(response.data.message?.email || response.data.message?.password);
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error(error || error?.email?.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const inputClass = (hasError) =>
        `w-full px-3 py-1.5 text-[11px] rounded-lg border transition-all duration-200 outline-none focus:ring-2 bg-white dark:bg-gray-900 text-gray-800 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 ${
            hasError 
                ? 'border-red-400 dark:border-red-500 focus:ring-red-200 dark:focus:ring-red-800' 
                : 'border-gray-200 dark:border-gray-700 focus:ring-gray-200 dark:focus:ring-gray-700 focus:border-gray-400 dark:focus:border-gray-500'
        }`;

    const labelClass = "block text-[9px] font-semibold text-gray-500 dark:text-gray-400 mb-1 uppercase tracking-wider flex items-center gap-1.5";
    const errorClass = "text-red-500 text-[9px] mt-0.5 font-medium";

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
            <div className="z-10 shrink-0">
                <NavBar />
            </div>
            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div
                        className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }
                    >
                        <Sidebar />
                    </div>
                )}
                <div className="flex-1 dark:bg-black p-4 md:p-6 w-full bg-gray-200 overflow-hidden flex items-center justify-center">
                    <div className="w-full ">

                        {/* Header */}
                        <div className="mb-2">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm">
                                        <FaUserPlus className="w-5 h-5 text-gray-700 dark:text-gray-300" />
                                    </div>
                                    <div>
                                        <h2 className="text-base font-bold text-gray-800 dark:text-white tracking-tight">Add New User</h2>
                                        <p className="text-[10px] text-gray-400 dark:text-gray-500">Create a new employee account</p>
                                    </div>
                                </div>
                                {/* <button
                                    onClick={() => naviagteToAllEmployee("/allEmployee")}
                                    className="flex items-center gap-1.5 text-[10px] font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors border border-gray-200 dark:border-gray-700 px-3 py-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
                                >
                                    <FaArrowLeft size={10} /> Back
                                </button> */}
                            </div>
                        </div>

                        {/* Form Card - Full height fit */}
                        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden">
                            
                            {/* Form Header */}
                            <div className="px-5 py-3 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/30 flex items-center gap-2">
                                <FaUserCog className="w-4 h-4 text-gray-500 dark:text-gray-400" />
                                <span className="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">Employee Details</span>
                                <span className="ml-auto text-[8px] text-gray-400 dark:text-gray-500">* Required fields</span>
                            </div>

                            {/* Form Body - No scroll, fits in viewport */}
                            <div className="p-5">
                                <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                        {/* Role */}
                                        <div className="md:col-span-2">
                                            <label htmlFor="role" className={labelClass}>
                                                <FaBriefcase size={11} /> Select Role *
                                            </label>
                                            <Select
                                                options={roles}
                                                labelField="name"
                                                valueField="id"
                                                placeholder="Select role..."
                                                style={{
                                                    padding: '0.3rem 0.5rem',
                                                    fontSize: '11px',
                                                    borderRadius: '0.5rem',
                                                    width: '100%',
                                                    borderColor: isDarkMode ? '#374151' : '#d1d5db',
                                                    backgroundColor: isDarkMode ? '#111827' : '#ffffff',
                                                    color: isDarkMode ? '#fff' : '#000',
                                                    minHeight: '36px',
                                                }}
                                                dropdownStyle={{
                                                    backgroundColor: isDarkMode ? '#1f2937' : '#ffffff',
                                                    color: isDarkMode ? '#fff' : '#000',
                                                }}
                                                onChange={handleSelectChange}
                                            />
                                            {errors.role && <p className={errorClass}>{errors.role.message}</p>}
                                        </div>

                                        {/* Name */}
                                        <div>
                                            <label className={labelClass} htmlFor="name">
                                                <FaUserCog size={11} /> Full Name *
                                            </label>
                                            <input
                                                className={inputClass(errors.name)}
                                                placeholder="Enter full name"
                                                type="text"
                                                id="name"
                                                {...register('name')}
                                                onChange={handleInputChange}
                                            />
                                            {errors.name && <p className={errorClass}>{errors.name.message}</p>}
                                        </div>

                                        {/* Company Name */}
                                        <div>
                                            <label className={labelClass} htmlFor="company_name">
                                                <FaBuilding size={11} /> Company Name *
                                            </label>
                                            <input
                                                className={inputClass(errors.company_name)}
                                                id="company_name"
                                                type="text"
                                                placeholder="Enter company name"
                                                {...register('company_name')}
                                                onChange={handleInputChange}
                                            />
                                            {errors.company_name && <p className={errorClass}>{errors.company_name.message}</p>}
                                        </div>

                                        {/* Email */}
                                        <div>
                                            <label className={labelClass} htmlFor="email">
                                                <FaEnvelope size={11} /> Email *
                                            </label>
                                            <input
                                                className={inputClass(errors.email)}
                                                id="email"
                                                type="email"
                                                placeholder="Enter email"
                                                {...register('email')}
                                            />
                                            {errors.email && <p className={errorClass}>{errors.email.message}</p>}
                                        </div>

                                        {/* Phone */}
                                        <div>
                                            <label className={labelClass} htmlFor="phone">
                                                <FaPhone size={11} /> Phone *
                                            </label>
                                            <input
                                                className={inputClass(errors.phone)}
                                                id="phone"
                                                type="tel"
                                                maxLength="10"
                                                placeholder="Enter 10 digit mobile no."
                                                {...register('phone')}
                                                onChange={handleInputChange}
                                            />
                                            {errors.phone && <p className={errorClass}>{errors.phone.message}</p>}
                                        </div>

                                        {/* Department */}
                                        <div>
                                            <label className={labelClass} htmlFor="department">
                                                <FaBriefcase size={11} /> Department *
                                            </label>
                                            <input
                                                className={inputClass(errors.department)}
                                                id="department"
                                                type="text"
                                                placeholder="Enter department"
                                                {...register('department')}
                                                onChange={handleInputChange}
                                            />
                                            {errors.department && <p className={errorClass}>{errors.department.message}</p>}
                                        </div>

                                        {/* Password */}
                                        <div className="relative">
                                            <label className={labelClass} htmlFor="password">
                                                <FaLock size={11} /> Password *
                                            </label>
                                            <input
                                                className={`${inputClass(errors.password)} pr-9`}
                                                id="password"
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="Enter password"
                                                {...register('password')}
                                            />
                                            <span
                                                className="absolute right-3 top-[30px] cursor-pointer text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                                            </span>
                                            {errors.password && <p className={errorClass}>{errors.password.message}</p>}
                                        </div>

                                    </div>

                                    {/* Submit */}
                                    <div className="flex items-center justify-end mt-5 pt-4 border-t border-gray-100 dark:border-gray-800 gap-3">
                                        <button
                                            type="button"
                                            onClick={() => reset()}
                                            className="text-[10px] font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800"
                                        >
                                            Reset
                                        </button>
                                        <button
                                            className="bg-gray-800 dark:bg-white hover:opacity-85 text-white dark:text-gray-800 text-[10px] font-semibold py-2 px-6 rounded-lg transition-all flex items-center gap-2 shadow-sm"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            <FaUserPlus size={12} />
                                            {isSubmitting ? "Creating..." : 'Create User'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Footer Note */}
                        <div className="mt-3 text-center">
                            <p className="text-[8px] text-gray-400 dark:text-gray-500">
                                All fields marked with <span className="text-red-400">*</span> are required
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUser;